import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class VideoList extends PureComponent {
    static propTypes = {
        sources: PropTypes.array.isRequired,
        currentSource: PropTypes.number.isRequired,
        changeCurrentSrc: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        };
    }

    clickSourceItem = index => {
        const { sources, changeCurrentSrc, currentSource } = this.props;

        if (index !== currentSource) {
            changeCurrentSrc(index, sources[index]);
        }
    };

    handleToggleClick = () => {
        this.setState({
            visible: !this.state.visible,
        });
    };

    render() {
        const { sources, currentSource } = this.props;
        const { visible } = this.state;

        return (
            <div className={styles.videoListBox} style={{ right: visible ? '0px' : '-138px' }}>
                <div className={styles.videoList}>
                    {sources.map((item, index) => (
                        <div
                            className={`${styles.videoListItem} ${index === currentSource ? styles.clicked : ''}`}
                            key={index}
                            onClick={() => this.clickSourceItem(index)}>
                            <img src={item.poster} />
                            <em>{item.title}</em>
                        </div>
                    ))}
                    <div
                        className={`${styles.toggleIcon} ${visible ? styles.toggleOff : styles.toggleOn}`}
                        onClick={this.handleToggleClick}
                    />
                </div>
            </div>
        );
    }
}

export default VideoList;
